import api from './index';
// axios
import request from '@/utils/request';

// 注册
export function unbind(params) {
  return request({
    url: api.unbind,
    method: 'put',
    data: params,
    hideloading: false
  });
}